var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "#8a3eb8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8293 21.1708C10.6633 21.0048 10.5803 20.8136 10.5803 20.597C10.5803 20.3795 10.6633 20.1877 10.8293 20.0217L14.851 16.0001L10.8293 11.9784C10.6633 11.8124 10.5806 11.6209 10.5811 11.4039C10.5806 11.1868 10.6633 10.9953 10.8293 10.8293C10.9953 10.6634 11.187 10.5804 11.4046 10.5804C11.6211 10.5804 11.8124 10.6634 11.9783 10.8293L16 14.851L20.0217 10.8293C20.1876 10.6634 20.3792 10.5806 20.5962 10.5812C20.8133 10.5806 21.0048 10.6634 21.1708 10.8293C21.3367 10.9953 21.4197 11.1871 21.4197 11.4046C21.4197 11.6212 21.3367 11.8124 21.1708 11.9784L17.149 16.0001L21.1708 20.0217C21.3367 20.1877 21.4199 20.3792 21.4205 20.5963C21.4199 20.8133 21.3367 21.0048 21.1708 21.1708C21.0048 21.3367 20.8135 21.4197 20.5969 21.4197C20.3794 21.4197 20.1876 21.3367 20.0217 21.1708L16 17.1491L11.9783 21.1708C11.8124 21.3367 11.6209 21.42 11.4038 21.4205C11.1868 21.42 10.9953 21.3367 10.8293 21.1708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXToggle);
export default __webpack_public_path__ + "static/media/X-Toggle.02185a2ae08e2a9e6f87ee28012803ae.svg";
export { ForwardRef as ReactComponent };